import { useState, useEffect } from 'react';
import { DropDownSelector } from "@lk-gtcom/ecomlab-components";
import { ModalComponent } from '../../../components/Modal/ModalComponent/ModalComponent';
import customHeaders, { getSpace } from '../../../common/headers';
import useGeneralStore from '../../../store/general';
import { useResponseHandler } from '../../../common/auth';
import { OrderStatusCard } from './OrderStatusCard/OrderStatusCard';
import './ModalOrderStatus.scss';

const ModalOrderStatus = ({ checkedItems, setIsModal, status }) => {
    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };
    const { handleTableResponse, handleRequestError } = useResponseHandler();

    const [postingResults, setPostingResults] = useState([]);
    const [loading, setLoading] = useState(true);

    const postings = checkedItems?.map((item) => ({
        api_id: item?.api_id,
        mp_id: item?.mp_id,
        posting_number: item?.['Номер отправления'],
        offer_id: item?.offer_id
    }));

    // Получение товаров и статусов
    const fetchGetStatus = () => {
        setLoading(true);
        const url = 'https://apps0.ecomru.ru:4449/v1/orders/cancel-choice';

        fetch(url, {
            method: 'POST',
            headers,
            body: JSON.stringify({ status: 'cancel', postings }),
        })
            .then(handleTableResponse)
            .then((json) => {
                const results = Array.isArray(json) ? json : json?.postings ?? json?.data ?? [];
                setPostingResults(results);
            })
            .catch(handleRequestError)
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        fetchGetStatus();
    }, []);

    const handleSubmit = ({ api_id, mp_id, offer_id, posting_number, cancel_reason_id, cancel_reason_message }) => {
        const url = 'https://apps0.ecomru.ru:4449/v1/orders/cancel';
        fetch(url, {
            method: 'POST',
            headers,
            body: JSON.stringify({
                api_id, 
                mp_id, 
                offer_id,
                posting_number,
                cancel_reason_id,
                cancel_reason_message
            }),
        })
            .then(handleTableResponse)
            .then((json) => console.log('Отмена принята:', json))
            .catch(handleRequestError);
    };

    return (
        <ModalComponent
            title='Отмена отправлений'
            onClose={(e) => setIsModal(false)}
            loading={loading}
            style={{ maxWidth: '800px' }}
            isNoData={!postingResults.length}
            descriptionNoData='Не удалось получить информацию по отправлениям.'
            child={
                <div className='modal-order-status__content'>
                    {!loading && postingResults.length > 0 &&
                        <div className='modal-order-status__cards'>
                            {postingResults.map((posting, idx) => (
                                <OrderStatusCard
                                    key={posting.posting_number ?? idx}
                                    posting={posting}
                                    onSubmit={handleSubmit}
                                />
                            ))}
                        </div>
                    }
                </div>
            }
        />
    );
};

export { ModalOrderStatus };
